import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SaleWeeklyComparisonOutput } from './models/sale-weekly-comparision-output';
import { TopSellingProduct } from './models/top-selling-product-output';
import { TopCancelledProduct } from './models/top-cancelled-product-output';

@Injectable({
    providedIn: 'root'
})
export class ReportService {
    private apiUrl = `${environment.apiUrl}/reports`;

    constructor(private http: HttpClient) { }



    getWeeklyComparision(startDate?: string): Observable<HttpResponse<SaleWeeklyComparisonOutput>> {
        let url = `${this.apiUrl}/weekly-comparision`;
        if(startDate) {
            url += `?startDate=${startDate}`;
        }
        return this.http.get<SaleWeeklyComparisonOutput>(url, { observe: 'response' });
    }

    getTopSellingProducts(period: number = 2, top: number = 50): Observable<HttpResponse<TopSellingProduct[]>> {
        const url = `${this.apiUrl}/top-selling-products?period=${period}&top=${top}`;
        return this.http.get<TopSellingProduct[]>(url, { observe: 'response' });
    }

    getTopCancelledProducts(period: number = 2, top: number = 50): Observable<HttpResponse<TopCancelledProduct[]>> {
        const url = `${this.apiUrl}/top-cancelled-products?period=${period}&top=${top}`;
        return this.http.get<TopCancelledProduct[]>(url, { observe: 'response' });
    }
}
